import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/redux';
import { useSiteSettings } from '@/brands';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const { showLogin } = useSiteSettings();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // With the login page switched off there is nowhere to send them — /login is
    // not mounted, so bouncing there would render the 404 page instead.
    if (!showLogin) return <Navigate to="/home" replace />;
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}